/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
        <path d="M10 11v5M14 11v5" />
    </Icon>
)

/* BARCODE ICON — PIN AND THE BARCODE CARD OF A DEALER */
export const BarcodeIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M4 5v14M8 5v14M12 5v14M16 5v14M20 5v14" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* INFO ICON */
export const InfoIcon = ({ size }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
    </Icon>
)

/* LOCK ICON — A VIEWER CHANGES NOTHING */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* STUDIO ICON */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 21V9l9-6 9 6v12" />
        <path d="M9 21v-6h6v6" />
    </Icon>
)

/* TABLE ICON — TABLE ACCESS */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* DOWNLOAD ICON */
export const DownloadIcon = ({ size = 15 }) => (
    <Icon size={size} width={2.4}>
        <path d="M12 3v12M7 11l5 5 5-5" />
        <path d="M4 20h16" />
    </Icon>
)

/* DEALER ICON — AVATAR AND EMPTY STATE */
export const DealerIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <path d="M4.5 20v-1.5A5.5 5.5 0 0 1 10 13h4a5.5 5.5 0 0 1 5.5 5.5V20" />
        <circle cx="12" cy="7.5" r="4" />
    </Icon>
)
